<template>
  <div>
    <a-modal
      title="新建/编辑"
      style="top: 20px;"
      :width="800"
      v-model="visible"
      :confirmLoading="confirmLoading"
      :footer="null"
      :maskClosable="false"
    >
      <a-form :form="form" :class="status == 1 ? 'readyOnly':''">
        <a-row>
          <a-col :span="4"></a-col>
          <a-col :span="12">
            <a-form-item style="display:none">
              <a-input v-decorator="['id']"/>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
              <a-select  v-decorator="['installationType',{ rules: [{ required: true, message: '请选择安装类别' }] }]" v-if="course == 1" @change="handleOrder">
                <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
              <a-select
                mode="multiple"
                v-else-if="course == 0"

                v-decorator="['installationType',{ rules: [{ required: true, message: '请选择安装类别' }] }]"
                @change="handChange1"
              >
                <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4"></a-col>
          <a-col :span="12">
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select  v-decorator="['orderTypeCode',{ rules: [{ required: true, message: '请选择订单类型' }] }]" v-if="course == 1">
                <a-select-option  v-for="type in data1" :key="type.orderTypeId">{{type.typeName}}</a-select-option>
              </a-select>
              <a-select
                mode="multiple"
                v-else-if="course == 0"

                v-decorator="['orderType',{ rules: [{ required: true, message: '请选择订单类型' }] }]"
                @change="handChange2"
              >
                <a-select-option  v-for="type in data2" :key="type.typeCode">{{type.typeName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4"></a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="成本类型">
              <a-select v-decorator="['costType']">
                <a-select-option  v-for="type in restaurantTypes1" :key="type.code"> {{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4"></a-col>
          <a-col :span="12">
            <a-form-item label="额外费用类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['priceName',{ rules: [{ required: true, message: '请输入额外费用类型' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="course == 1">
          <a-col :span="4"></a-col>
          <a-col :span="12">
            <a-form-item label="添加时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                v-model="bondTime"
                style="width: 100%"
                show-time
                @change="onChange1"
                format="YYYY-MM-DD HH:mm:ss"
                @ok="onOk1" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4"></a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="示例图">
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  accept="image/*"
                  listType="picture-card"
                  :fileList="fileList"
                  :headers="headers"
                  :beforeUpload="beforeUpload"
                  @preview="handPreview"
                  @change="handChange"
                >
                  <div v-if="fileList.length < 1">
                    <a-icon type="plus"/>
                    <div class="ant-upload-text">示例图</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handCancel">
                  <img alt="example" style="width: 100%" :src="imageUrl"/>
                </a-modal>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10"></a-col>
          <a-col :span="6">
            <a-button @click="getSave" type="primary">保存</a-button>
            <a-button style="margin-left: 10px " @click="showModal">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      title="配置"
      style="top: 20px;"
      :width="800"
      v-model="disable"
      :confirmLoading="confirmLoading"
      :footer="false"
    >
      <a-form :form="form1">
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称" style="width:410px;">
              <a-input-search v-model="text" enter-button @search="onSearch" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div>
        <span style="margin-left: 10%">* 企业配置 : </span>
        <a-tree
          checkable
          v-model="checkedKeys"
          :expanded-keys="expandedKeys"
          :auto-expand-parent="autoExpandParent"
          :defaultExpandedKeys="['enterprise']"
          @expand="onExpand"
          :treeData="dataList"
          :defaultCheckedKeys="checkedKeys"
          style="margin-left: 20%"
          @check="onCheck"
        >
          <template slot="title" slot-scope="{title}">
            <span v-if="title.indexOf(searchValue) > -1">
              {{title.substr(0, title.indexOf(searchValue))}}
            <span style="color: #f50">{{searchValue}}</span>
              {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
            </span>
            <span v-else>{{title}}</span>
          </template>
        </a-tree>
      </div>
      <a-row type="flex" justify="center">
        <a-col :span="6">
          <div v-if="isShow == 0">
            <a-button @click="relevance" type="primary">关联</a-button>
            <a-button style="margin-left: 18px " @click="exclude">排除</a-button>
          </div>
          <div v-else-if="isShow == 1">
            <a-button @click="relevance" type="primary" v-if="relevanceType == 1">关联</a-button>
            <a-button style="margin-left: 18px " @click="exclude" v-else-if="relevanceType == 0">排除</a-button>
          </div>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
  import { getInfo,save,update,getOrderTypeList,getOrderType,insertEopList,getSelectTree,selectEopList } from '@/api/basicdatas/ExtrachargetypeManagement'
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  import pick from 'lodash.pick'
  import {getDictMap} from "../../../utils/dict"

  const treeData = [];

  export default {
    name: 'ModelModal',
    props: {
    },
    components: {
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        text1:'',
        disable: false,
        visible: false,
        confirmLoading: false,
        mdl: {},
        form: this.$form.createForm(this),
        form1: this.$form.createForm(this),
        restaurantTypes:[],
        restaurantTypes1:[],
        data1:[],
        data2:[],
        queryParam:{},
        // 树状图********************************
        expandedKeys: [],  //受控展开的树节点
        // autoExpandParent: false,
        checkedKeys: [],//复选
        treeData,
        dataList: [],
        treeList:[{
          title:'',
          key:'',
          children:''
        }],// 筛选后的值
        // searchValue: '',
        autoExpandParent: true,
        course:0,
        recordId:0,
        isShow:0,
        relevanceType:0,
        text:'',
        // agentlisttwo:'',
        // 上传
        uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=basicdatas',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        fileList: [],
        previewVisible: false,
        imageUrl: "",
        isType:0,
        status:0,
        bondTime:null,
        bondTimeTrue:null,
      }
    },
    async created () {
      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
      this.restaurantTypes1 = [];
      this.restaurantOperTypeMap1 = await getDictMap('cost_type');
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({code: key, label: value})
      })
    },
    watch: {
      checkedKeys(val) {
        this.checkedKeys = val;
        // console.log(this.checkedKeys,'监听事件')
      },
    },

    methods: {
      // 时间控件
      onChange1(date, dateString) {
        // console.log('Formatted Selected Time: ',date, dateString);
        this.bondTime = date
        this.bondTimeTrue = dateString
      },
      selectText(){
        // console.log(this.text1)
      },
      // 取消
      showModal () {
        this.visible = !this.visible
      },
      add () {
        this.fileList = []
        this.imageUrl = ''
        this.form.resetFields()
        this.data2 = []
        this.course=0
        this.visible = true
      },
      edit (record,status) {
        this.course=1
        this.status = status
        this.bondTime = null
        let _this = this
        // console.log(record)
        getInfo(record.id).then(res=> {
          // console.log(res)
          this.mdl = Object.assign(res)
          this.visible = true
          if(this.mdl.createTime != null){
            this.bondTime = moment(this.mdl.createTime)
          }else{
            this.bondTime = null
          }
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.mdl, 'id', 'costType', 'installationType', 'orderTypeCode', 'priceName',))
            if(res.priceUrl != null) {
              this.getImgToBase64(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + res.priceUrl + '&token=' + Vue.ls.get(ACCESS_TOKEN), function (data) {
                _this.fileList = [{
                  uid: '',
                  name: '',
                  thumbUrl: data,
                  url: res.priceUrl
                }]
              })
            }else{
              this.fileList = []
            }
          })
        })
        this.handleOrder(record.installationType)
        // getOrderTypeList(record.installationType).then(res => {
        //   console.log(res.rows)
        //   this.data1 = res.rows
        // })
      },
      beforeUpload(file){
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          this.$message.error('上传文件格式不支持!');
          this.isType = 1
          return false
        }else{
          this.isType = 0
        }
      },
      handChange({fileList}) {
        // console.log(fileList)
        if(this.isType == 0) {
          this.fileList = fileList;
          this.imageUrl = fileList[0].response.url
          // console.log(this.imageUrl)
        }
      },
      handPreview(file) {
        // console.log(file)
        if(file.response){
          this.imageUrl = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.response.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
        }else{
          this.imageUrl = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
        }
        this.previewVisible = true;
      },
      handCancel() {
        this.previewVisible = false;
      },
      deploy(record){
        // console.log(record)
        this.text = ''
        this.recordId = record.id
        this.disable = true
        // this.checkedKeys = []
        let arr = []
        getSelectTree().then(res=>{
          // console.log(res.data)
          if (res.code == 0){
            this.treeData = res.data
            this.dataList = this.treeData
            selectEopList(record.id).then(res => {
              // console.log(res.rows)
              if (res.total == 0){
                this.isShow = 0
              }else{
                this.isShow = 1
              }
              // 显示排除 或者 关联
              for (var item in res.rows){
                arr.push(res.rows[item].enterpriseId)
                if (res.rows[0].relevanceType == 0){
                  this.relevanceType = 0
                }else if (res.rows[0].relevanceType == 1){
                  this.relevanceType = 1
                }
              }
              // console.log(arr)
              this.checkedKeys = arr
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      onSearch (value) {
        let arr = []
        let arr11 = []
        // console.log(value)
        if(value != "") {
          let children = this.treeData[0].children
          // console.log('所有公司',children)
          for (let i in children) {
            let title = children[i].title
            if (title.indexOf(value) != -1) {
              // console.log('筛选后',children[i])
              arr11.push(children[i])
            }
          }
          // console.log(arr11)
          this.treeList[0].title = "企业",
          this.treeList[0].key = "enterprise"
          this.treeList[0].children = arr11
          console.log(this.treeList)
          this.dataList = this.treeList
        }else{
          this.dataList = this.treeData
        }
        this.$nextTick(()=>{
          selectEopList(this.recordId).then(res => {
            // 显示排除 或者 关联
            for (let item in res.rows){
              arr.push(res.rows[item].enterpriseId)
              if (res.rows[0].relevanceType == 0){
                this.relevanceType = 0
              }else if (res.rows[0].relevanceType == 1){
                this.relevanceType = 1
              }
            }
            this.checkedKeys = arr
          })
        })
      },
      handleOrder(value){
        getOrderTypeList(value).then(res => {
          // console.log(res.rows)
          this.data1 = res.rows
        })
      },
      handChange1(value){
        console.log(`selected ${value}`);
        getOrderType(value).then(res => {
          // console.log(res.rows)
          let rows = res.rows
          let result = []
          this.data2 = []
          for (let i = 0; i < rows.length; i++) {
            // console.log(rows[i])
            result = result.concat(rows[i]);
          }
          this.data2 = result
          // console.log(this.data2)
        })
      },
      handChange2(value){
        console.log(`selected ${value}`);
      },
      // 保存
      getSave(e){
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            // console.log('Received values of form: ', values)
            values.priceUrl = this.imageUrl
            this.confirmLoading = true
            if (this.course==0){
              values.installationType = values.installationType.join(',')
              values.orderType = values.orderType.join(',')
              save(values).then(res => {
                if (res.code === 0) {
                  if(res.data != '订单类型重复'){
                    this.$message.success('保存成功')
                    this.$emit('ok',1)
                    this.visible = false
                  }else{
                    this.$message.error(res.data)
                  }
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              }).finally(() => {
                this.confirmLoading = false
              })
            } else if (this.course==1){
              values.createTime = this.bondTimeTrue
              update(values).then(res => {
                // console.log(values)
                if (res.code === 0) {
                  if(res.data != '订单类型重复'){
                    this.$message.success(res.data)
                    this.$emit('ok',2)
                    this.visible = false
                  }else{
                    this.$message.error(res.data)
                  }
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              }).finally(() => {
                this.confirmLoading = false
              })
            }
          }
        })
      },
      // 树状图*********************************
      onChange(e){
        // const value = e.target.value;
        // console.log(value)
        // const expandedKeys = this.expandedKeys
        //   .map(item => {
        //     if (item.key.indexOf(value) > -1) {
        //       return getParentKey(item.key, treeData);
        //     }
        //     return null;
        //   })
        //   .filter((item, i, self) => item && self.indexOf(item) === i);
        // Object.assign(this, {
        //   expandedKeys,
        //   searchValue: value,
        //   autoExpandParent: true,
        // });
      },
      // 展开/收起节点时触发
      onExpand(expandedKeys) {
        // console.log('onExpand', expandedKeys);
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
      },
      onCheck(checkedKeys) {
        // console.log('onCheck', checkedKeys);
        this.checkedKeys = checkedKeys;
      },

      // 关联按钮
      relevance () {
        // if(this.checkedKeys.length != 0){
          this.confirmLoading = true
          let checkedKeys = this.checkedKeys.join(',')
          insertEopList({enterpriseId:checkedKeys,relevanceType:1,otherPriceId:this.recordId}).then(res => {
            console.log(res)
            if (res.code === 0) {
              // console.log(11111111)
              this.$message.success(res.data)
              this.disable = false
              this.$emit('ok')
              // console.log(this.checkedKeys)
              this.checkedKeys.splice(0, this.checkedKeys.length)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          }).finally(() => {
            this.confirmLoading = false
          })
        // }else{
        //   this.$message.error('请选择企业！')
        // }
      },
      // 排除
      exclude(){
        // if(this.checkedKeys.length != 0){
          this.confirmLoading = true
          let checkedKeys = this.checkedKeys.join(',')
          insertEopList({enterpriseId:checkedKeys,relevanceType:0,otherPriceId:this.recordId}).then(res => {
            console.log(res)
            if (res.code == 0) {
              // console.log(2222222)
              this.$message.success(res.data)
              this.disable = false
              this.$emit('ok')
              // console.log(this.checkedKeys)
              this.checkedKeys.splice(0, this.checkedKeys.length)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          }).finally(() => {
            this.confirmLoading = false
          })
        // }else{
        //   this.$message.error('请选择企业！')
        // }
      },
      //将图片转换为Base64
      getImgToBase64(url,callback){
        var canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d'),
          img = new Image;
        img.crossOrigin = 'Anonymous';
        img.onload = function(){
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img,0,0);
          var dataURL = canvas.toDataURL('image/png');
          callback(dataURL);
          canvas = null;
        };
        img.src = url;
      },
    },
    computed: {

    }
  }
</script>
<style scoped>
  .readyOnly{
    pointer-events: none;
  }
</style>
